export const MODULE_PALETTE = {
  dashboard: '#6d28d9',
  traffic: '#3b82f6',
  articles: '#06b6d4',
  projects: '#f97316',
  updates: '#8b5cf6',
  settings: '#94a3b8',
  backups: '#14b8a6',
  appointments: '#ef4444',
  menus: '#22c55e',
  scripts: '#9ca3af',
  team: '#a78bfa',
  languages: '#22c55e',
  accessibility: '#eab308',
  resources: '#0ea5e9',
  databases: '#38bdf8',
  gallery: '#10b981',
  clients: '#ec4899',
  sites: '#0ea5e9',
  admin_settings: '#94a3b8',
  employees: '#dc2626',
  logs: '#f59e0b',
};

export function moduleColor(moduleKey, fallback = '#7c3aed') {
  const k = String(moduleKey || '');
  return MODULE_PALETTE[k] || fallback;
}

export function orderModules(modules) {
  const list = Array.isArray(modules) ? modules.filter(Boolean) : [];
  const settings = [];
  const rest = [];
  for (const m of list) {
    if (String(m?.key || '') === 'settings') settings.push(m);
    else rest.push(m);
  }
  return [...rest, ...settings];
}
